var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"coupon-section"},[(_vm.coupon)?_c('div',[_c('WizardForm',{attrs:{"coupon":_vm.coupon},on:{"coupon-changed":_vm.couponChanged}})],1):_c('div',{staticClass:"text-center"},[_c('b-spinner')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }